<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h2>Customers</h2>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="customers"
        :search="search"
        :loading="loading"
      ></v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import AdminLayout from "@/layouts/AdminLayout";
import api from "../../services/axiosconfig";

export default {
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        { text: "Ledger Ref", align: "start", value: "custledgref" },
        { text: "Customer Name", align: "start", value: "clastname" },
        { text: "Email", align: "start", value: "cemail" },
        { text: "Contact", align: "start", value: "ccontactname" },
      ],
      customers: [],
    };
  },
  mounted() {
    this.getCustomers();
  },
  created() {
    this.$emit(`update:layout`, AdminLayout);
  },
  methods: {
    async getCustomers() {
      try {
        this.loading = true;
        const response = await api.get("/aejmis/api/customers");
        this.customers = response.data;
        this.loading = false;
        return;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.loading = false;
        this.$toasted.global.optimus_error({
          message: "Could not retrieve information. Try after sometime.",
        });
      }
    },
  },
};
</script>
